import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { contactKeys } from '@/lib/queryKeys';
import type { ContactSummary } from '@/types/contact';

export function useContactSummary(contactId: string) {
  return useApiQuery<ContactSummary>({
    queryKey: contactKeys.summary(contactId),
    queryFn: () => apiGet<ContactSummary>(operationsClient, `/contacts/${contactId}/summary`),
    enabled: Boolean(contactId),
    showErrorToast: false,
  });
}
